import { useState } from "react";
import { KeetaReports } from "./KeetaReports";

const TABS = [["category", "الكاتقري"], ["face", "تحقق الوجه"], ["validity", "الصلاحية"], ["fake_gps", "Fake GPS"]];

export const SalaryFinalReports = ({ month, setMonth, canEdit }) => {
  const [kind, setKind] = useState("category");
  const m = month || new Date().toISOString().slice(0, 7);
  return (
    <div className="space-y-3" data-testid="salary-final-reports">
      <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50/60 p-3">
        <div className="flex-1 min-w-[220px]">
          <p className="font-heading font-bold text-emerald-900">التقارير النهائية للرواتب — كيتا شرائح</p>
          <p className="text-xs text-emerald-800">هذه التقارير فقط هي التي تُخصم وتُحتسب في رواتب الشهر. تقارير قسم المناديب للاطلاع والمشرفين ولا تنعكس على الرواتب.</p>
        </div>
        <label className="flex items-center gap-2 text-sm font-semibold text-slate-700">شهر الرواتب
          <input type="month" value={m} onChange={(e) => e.target.value && setMonth(e.target.value)} className="h-9 rounded-lg border border-slate-200 bg-white px-2 text-sm" data-testid="sfr-month" />
        </label>
      </div>
      <div className="flex gap-1 overflow-x-auto border-b border-slate-200" data-testid="sfr-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setKind(k)} data-testid={`sfr-tab-${k}`}
            className={`whitespace-nowrap border-b-2 px-4 py-2 text-sm font-semibold transition-colors ${kind === k ? "border-amber-400 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-700"}`}>{l}</button>
        ))}
      </div>
      <KeetaReports key={`${kind}-${m}`} kind={kind} canEdit={canEdit} onKind={setKind} scope="payroll" fixedMonth={m} />
    </div>
  );
};
